import { render, staticRenderFns } from "./PartsRequestComponent.vue?vue&type=template&id=74678f0f&scoped=true&"
import script from "./PartsRequestComponent.vue?vue&type=script&lang=js&"
export * from "./PartsRequestComponent.vue?vue&type=script&lang=js&"
import style0 from "./PartsRequestComponent.vue?vue&type=style&index=0&id=74678f0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74678f0f",
  null
  
)

export default component.exports